// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { ShareGetString, UserShareIconButtonGetString, ShareUserMenuItemGetString, ShareModalGetString, ArtistMerchShareIconButtonGetString } from './types.generated'

const shareLocales = ['en-US'] as const

export const getString: ShareGetString = i18nBundle('share', shareLocales).getString
export const getStringShare: ShareGetString = getString

const userShareIconButtonLocales = ['en-US'] as const

export const getStringUserShareIconButton: UserShareIconButtonGetString = i18nBundle('UserShareIconButton', userShareIconButtonLocales).getString

const shareUserMenuItemLocales = ['en-US'] as const

export const getStringShareUserMenuItem: ShareUserMenuItemGetString = i18nBundle('ShareUserMenuItem', shareUserMenuItemLocales).getString

const shareModalLocales = ['en-US'] as const

export const getStringShareModal: ShareModalGetString = i18nBundle('ShareModal', shareModalLocales).getString

const artistMerchShareIconButtonLocales = ['en-US'] as const

export const getStringArtistMerchShareIconButton: ArtistMerchShareIconButtonGetString = i18nBundle('ArtistMerchShareIconButton', artistMerchShareIconButtonLocales).getString

